/* This file is autogenerated, see readme.md for instructions */
import EventsSegmentationSvgIcon from '@bloomreach/banana-theme/icons/events-segmentation.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const EventsSegmentationIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <EventsSegmentationSvgIcon />
    </Icon>
  );
});

EventsSegmentationIcon.displayName = 'EventsSegmentationIcon';

export default EventsSegmentationIcon;
